import {
  FeatherCheckCircle,
  FeatherClock,
  FeatherTrendingUp,
  FeatherXCircle,
} from '@subframe/core';
import type { ComponentType } from 'react';

import type { TrialAction, TrialStatus } from '../types';

type BadgeVariant = 'success' | 'warning' | 'error' | 'neutral' | 'brand';

interface StatusConfig {
  label: string;
  variant: BadgeVariant;
  icon: ComponentType<{ className?: string }>;
}

export const trialStatusConfig: Record<TrialStatus, StatusConfig> = {
  ATIVO: {
    label: 'Ativo',
    variant: 'success',
    icon: FeatherCheckCircle,
  },
  EXPIRADO: {
    label: 'Expirado',
    variant: 'error',
    icon: FeatherXCircle,
  },
  ENCERRADO: {
    label: 'Encerrado',
    variant: 'neutral',
    icon: FeatherXCircle,
  },
  CONVERTIDO: {
    label: 'Convertido',
    variant: 'brand',
    icon: FeatherTrendingUp,
  },
};

export const trialActionLabel: Record<TrialAction, string> = {
  CRIACAO: 'Trial iniciado',
  EXTENSAO: 'Trial estendido',
  CONVERSAO: 'Convertido para plano pago',
  ENCERRAMENTO_MANUAL: 'Encerrado manualmente',
  BLOQUEIO_AUTOMATICO: 'Bloqueado automaticamente',
  APROVACAO_REATIVACAO: 'Reativação aprovada',
};

export const trialActionVariant: Record<TrialAction, BadgeVariant> = {
  CRIACAO: 'success',
  EXTENSAO: 'warning',
  CONVERSAO: 'brand',
  ENCERRAMENTO_MANUAL: 'error',
  BLOQUEIO_AUTOMATICO: 'error',
  APROVACAO_REATIVACAO: 'warning',
};

export const trialActionIcon: Record<TrialAction, ComponentType<{ className?: string }>> = {
  CRIACAO: FeatherCheckCircle,
  EXTENSAO: FeatherClock,
  CONVERSAO: FeatherTrendingUp,
  ENCERRAMENTO_MANUAL: FeatherXCircle,
  BLOQUEIO_AUTOMATICO: FeatherXCircle,
  APROVACAO_REATIVACAO: FeatherCheckCircle,
};
